import { computed, action } from 'mobx';

import { AppManager, Input, Variables } from 'core/index';

import { ProjectConnManager } from 'apps/project/connManager';

import { CollectionModel, CollectionApp } from 'apps/collection/app';
import {
  CollectionMutation,
  CollectionQuery,
  CollectionProjectsQuery,
} from 'apps/collection/gql';

export class CollectionAppManager extends AppManager {
  static registryName = 'CollectionAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('collection', CollectionApp);
    this.projectsConn = new ProjectConnManager(this, {
      initialBatchSize: 27,
      sortBy: 'recent',
      loadMoreQuery: CollectionProjectsQuery,
    });

    this.variables = new Variables({
      space: () => this.params.get('profile') || this.params.get('initiative'),
      slug: () => this.params.get('slug'),
    });

    this.projectsConn.variables = new Variables({
      space: () => this.variables.space,
      slug: () => this.variables.slug,
      sortBy: () => this.projectsConn.sortBy,
      batchSize: () =>
        this.projectsConn.loadedMore
          ? this.projectsConn.batchSize
          : this.projectsConn.initialBatchSize,
      cursor: () => this.projectsConn.endCursor,
      filterBy: () => this.projectsConn.filterBy,
      contains: () => this.projectsConn.contains,
    });

    this.collectionInput = new Input({
      id: () => this.collection.id,
      deleted: () => this.collection.deleted,
      name: () => this.collection.name,
      description: () => this.collection.description,
      tags: () =>
        this.collection.tags.map(tag => ({
          id: tag.id,
          name: tag.name,
          deleted: tag.deleted,
        })),
    });

    this.variables.onChange(['space', 'slug'], this.NewVariables);
  }

  @computed get loading() {
    return this.queries.get('collection')?.loading;
  }

  @action NewVariables = () => {
    // this.projectsConn.Reset();
    this.projectsConn.loadMore();
    this.NewCollectionQuery();
  };

  @action NewCollectionQuery = () => {
    const q = new CollectionQuery(this, {
      queryKey: 'collection',
      onSysErr: this.OnCollectionError,
    });
    q.process(
      collection => CollectionModel.Load(collection),
      this.CollectionUpdate,
    );
    q.query();
  };

  @action OnCollectionError = () => {
    // ...
  };

  @action CollectionUpdate = collectionModel => {
    this.collection = collectionModel;
  };

  @action SubmitCollection = options => {
    this.mutations.push(CollectionMutation.New(this.collectionInput, options));
  };
}
